export enum KeepAliveWorkerStatus {
  Start,
  Tick,
  End,
}

export enum SessionRefreshStatus {
  STARTED = 'REFRESH_STARTED',
  COMPLETED = 'REFRESH_COMPLETED',
  FAILED = 'REFRESH_FAILED',
}

export interface KeepAliveDataWorker {
  status: KeepAliveWorkerStatus;
}

export interface SessionRefreshDataChannel {
  type: SessionRefreshStatus;
  timestamp: number;
}

export const SESSION_REFRESH_CHANNEL = 'od-session-refresh';

const SECOND_MS = 1000;
const MINUTE_MS = 60 * SECOND_MS;

// Worker check interval
export const CHECK_INTERVAL_MS = MINUTE_MS;

// Refresh internal token 2 minutes before expiration
export const INTERNAL_TOKEN_BUFFER_MS = 2 * MINUTE_MS;

// Mark internal token as expired 30 seconds before expiration
export const INTERNAL_TOKEN_EXPIRATION_LIMIT_MS = 30 * SECOND_MS;

// Internal token lifetime: 10 minutes (configured in backend)
export const INTERNAL_TOKEN_LIFETIME_MS = 10 * MINUTE_MS;

// Internal token refresh timeout: 10 seconds
export const INTERNAL_TOKEN_TIMEOUT = 10 * SECOND_MS;

// Refresh MSAL token 5 minutes before expiration
export const MSAL_TOKEN_BUFFER_MS = 5 * MINUTE_MS;

// Refresh MSAL access token 5 minutes before expiration
export const MSAL_ACCESS_TOKEN_BUFFER_MS = 5 * MINUTE_MS;
